<template>
  <div>
    <b-container fluid class="fullHeight padding-top-top-20px">
      <b-row>
        <b-col cols="3">
        </b-col>
        <b-col class="shadow">
          <b-container fluid class="fullHeight">
            <b-row>
              <b-col cols="3"></b-col>
              <b-col>
                <b-img src="https://source.tutorabc.com/BD/SCRM/image/SaleBusinessCard/logo.png" fluid center ></b-img>
              </b-col>
              <b-col cols="3"></b-col>
            </b-row>
            <b-row class="padding-bottom-20px">
              <b-col cols="3"></b-col>
              <b-col>
                <div :class="headerIconClass">
                  <img v-bind:src="saleBusinessCard.pictureUrl" ref="headerIconImg" style="margin: 0;" />
                </div>
              </b-col>
              <b-col cols="3"></b-col>
            </b-row>
            <b-row class="text-center title-font-style" v-if="saleBusinessCard.jobTitle">
              <b-col>
                {{ saleBusinessCard.jobTitle }}
              </b-col>
            </b-row>
            <b-row class="text-center salesName-font-style">
              <b-col :class="salesNameFontColorClass">
                {{ saleBusinessCard.salesName }}
              </b-col>
            </b-row>
            <hr/>
            <b-row class="selfIntro-font-style padding-bottom-20px pre-line">
              <b-col v-html="saleBusinessCard.selfIntro.replace(/\n/g, '<br>')">
              </b-col>
            </b-row>
            <b-row class="padding-bottom-20px">
              <b-col>
                <b-button pill block :class="salesNameButtonColorClass">轉發名片</b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <b-col cols="3">
        </b-col>
      </b-row>
    </b-container>
    
  </div>
</template>

<script>
import store_saleBusinessCard from "@/vuex/store_saleBusinessCard.js";
import { SaleBusinessCardHandler } from "../../handler/SaleBusinessCardHandler.js";
import { SocialPairedBasisInfoHandler } from "../../handler/SocialPairedBasisInfoHandler.js";
import { HeaderIconHandler } from "@/handler/HeaderIconHandler.js";

export default {
  data() {
    return {
      headerIconSizeObject:{height:"",width:""}
    };
  },
  created() {
    this.initBusinessCardInfo();
  },
  computed: {
    saleBusinessCard() {
      return store_saleBusinessCard.state;
    },
    salesNameFontColorClass(){
      return {
        fontcolorgolden: this.saleBusinessCard.colorEnum == 0,
        fontcolorpink: this.saleBusinessCard.colorEnum == 1,
        fontcolorblack: this.saleBusinessCard.colorEnum == 2,
        fontcolorgreen: this.saleBusinessCard.colorEnum == 3,
        fontcolorblue: this.saleBusinessCard.colorEnum == 4,
        fontcolororange: this.saleBusinessCard.colorEnum == 5,
        fontcolorpurple: this.saleBusinessCard.colorEnum == 6
      };
    },
    salesNameButtonColorClass(){
      return {
        buttoncolorgolden: this.saleBusinessCard.colorEnum == 0,
        buttoncolorpink: this.saleBusinessCard.colorEnum == 1,
        buttoncolorblack: this.saleBusinessCard.colorEnum == 2,
        buttoncolorgreen: this.saleBusinessCard.colorEnum == 3,
        buttoncolorblue: this.saleBusinessCard.colorEnum == 4,
        buttoncolororange: this.saleBusinessCard.colorEnum == 5,
        buttoncolorpurple: this.saleBusinessCard.colorEnum == 6,
        buttonfontstyle: true
      };
    },
    headerIconClass(){
      return {
        PreViewCardHeaderIconsquare: true,
      };
    }
  },
  methods: {
    initBusinessCardInfo: function() {
      var staff = this.GetLoginStaff();
      var staffInfo = SocialPairedBasisInfoHandler.GetStaffInfo(staff.staffid);

      var businesscard_ = SaleBusinessCardHandler.GetBusinessCard(staff.staffid);
      if (businesscard_ != null && staffInfo != null && !this.dialogVisible) {
        store_saleBusinessCard.dispatch(
          "setPictureUrl",
          staffInfo.PictureUrl
        );
        store_saleBusinessCard.dispatch(
          "setJobTitle",
          staffInfo.JobTitle
        );
        store_saleBusinessCard.dispatch(
          "setSalesName",
          staffInfo.CName + " " + staffInfo.FirstName.split('_')[0]
        );
        store_saleBusinessCard.dispatch(
          "setSelfIntro",
          businesscard_.SelfIntroduction
        );
        store_saleBusinessCard.dispatch(
          "setColorEnum",
          businesscard_.Version.toString()
        );
        
        HeaderIconHandler.getImgSize(staffInfo.PictureUrl).then(res=>{ 
          this.headerIconSizeObject = res;
          if(this.headerIconSizeObject.height > this.headerIconSizeObject.width){
            this.$refs.headerIconImg.style.margin = HeaderIconHandler.ComputeMarginVertical(this.headerIconSizeObject.width,this.headerIconSizeObject.height,120);
          }
          if(this.headerIconSizeObject.height < this.headerIconSizeObject.width){
            this.$refs.headerIconImg.style.margin = HeaderIconHandler.ComputeMarginHorizontal(this.headerIconSizeObject.width,this.headerIconSizeObject.height,120);
          }
        });
      }
    }
  },
};
</script>

<style>
.text-center {
    text-align: center!important;
}
.padding-bottom-20px {
    padding-bottom: 20px!important;
}
.padding-top-top-20px {
    padding-top: 20px!important;
}
hr {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.title-font-style{
  font-size: large !important;
  font-weight: bolder !important;
  color: #999999 !important;
}
.salesName-font-style{
  font-size: xx-large !important;
  font-weight: bolder !important;
}
.buttonfontstyle{
  font-size: xx-large !important;
  letter-spacing: 10px !important;
  pointer-events: none !important;
}
.selfIntro-font-style{
  font-size: x-large !important;
  color: #666666 !important;
}
.buttoncolorgolden{
  background-color: #A6875C !important;
  border-color: #A6875C !important;
}
.fontcolorgolden{
  color: #A6875C !important;
}
.buttoncolorpink{
  background-color: #ED4C7C !important;
  border-color: #ED4C7C !important;
}
.fontcolorpink{
  color: #ED4C7C !important;
}
.buttoncolorblack{
  background-color: #404040 !important;
  border-color: #404040 !important;
}
.fontcolorblack{
  color: #404040 !important;
}
.buttoncolorgreen{
  background-color: #3FA76F !important;
  border-color: #3FA76F !important;
}
.fontcolorgreen{
  color: #3FA76F !important;
}
.buttoncolorblue{
  background-color: #497FDB !important;
  border-color: #497FDB !important;
}
.fontcolorblue{
  color: #497FDB !important;
}
.buttoncolororange{
  background-color: #ED5F36 !important;
  border-color: #ED5F36 !important;
}
.fontcolororange{
  color: #ED5F36 !important;
}
.buttoncolorpurple{
  background-color: #7B6FF5 !important;
  border-color: #7B6FF5 !important;
}
.fontcolorpurple{
  color: #7B6FF5 !important;
}

.PreViewCardHeaderIconsquare {
  display:inline-block !important;
  position:relative !important;
  width:160px !important;
  height:160px !important;
  overflow:hidden !important;
  border-radius:50% !important;
  margin: 15% !important;
}
.PreViewCardHeaderIconsquare img {
  width: 100% !important;
  height: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/SaleBusinessCardPreview.vue